import React, { useState, useEffect } from 'react'
import { AnimatePresence } from 'framer-motion'
import CameraView from './components/CameraView'
import ArtworkSheet from './components/ArtworkSheet'
import NoMatchSheet from './components/NoMatchSheet'
import { InstallBanner } from './components/InstallBanner'
import { useRecognition } from './hooks/useRecognition'
import { useInstallPrompt } from './hooks/useInstallPrompt'

function App() {
  const { result, error, recognize, clear } = useRecognition()
  const { canInstall, triggerInstall } = useInstallPrompt()
  const [showOverlay, setShowOverlay] = useState(false)

  useEffect(() => {
    if (result || error) setShowOverlay(true)
  }, [result, error])

  const handleClose = () => {
    setShowOverlay(false)
    clear()
  }

  const artwork = Array.isArray(result) && result.length > 0 ? result[0] : null
  const hasArtwork = Boolean(artwork) && !error

  return (
    <>
      <CameraView onCapture={recognize} />
      <AnimatePresence mode="wait">
        {showOverlay && (
          hasArtwork
            ? <ArtworkSheet key="match"    isOpen={showOverlay} artwork={artwork} onClose={handleClose} />
            : <NoMatchSheet key="no-match" isOpen={showOverlay} error={error}    onClose={handleClose} />
        )}
      </AnimatePresence>
      <InstallBanner canInstall={canInstall} onInstall={triggerInstall} />
    </>
  )
}

export default App
